import api from "@/services/api";
import { ENDPOINTS_NOTIFICATIONS } from "@/services/endpoints";

export const listNotifications = () =>
  api.get(ENDPOINTS_NOTIFICATIONS.list).then((r) => r.data);

export const markNotificationRead = (id) =>
  api.post(ENDPOINTS_NOTIFICATIONS.read(id)).then((r) => r.data);

export const markAllNotificationsRead = () =>
  api.post(ENDPOINTS_NOTIFICATIONS.readAll).then((r) => r.data);
